/** "2 documents, 1 contact" — only the non-zero parts. */
export function describePending(documents: number, contacts: number): string {
  const parts = nonZeroParts(documents, contacts);
  return parts.length === 0 ? 'Nothing — all changes are on Mon Ami' : parts.join(', ');
}

/**
 * "2 documents and 1 contact" for the success banner, or null when nothing was
 * left behind by the last push sweep.
 */
export function describeLeftBehind(documents: number, contacts: number): string | null {
  const parts = nonZeroParts(documents, contacts);
  return parts.length === 0 ? null : parts.join(' and ');
}

function nonZeroParts(documents: number, contacts: number): string[] {
  const parts: string[] = [];
  if (documents > 0) parts.push(plural(documents, 'document'));
  if (contacts > 0) parts.push(plural(contacts, 'contact'));
  return parts;
}

function plural(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
